module.exports = __webpack_public_path__ + "static/media/imagem35.ded5ba4e.jpeg";